module.exports = __webpack_public_path__ + "img/5769c5020276ff39c1463b4b6cfa4003.jpg";